import React from 'react';
import { Box, Skeleton } from '@cubeyou-team/hx-react-components';

const ResultSearchItemLoader = () => {
  const speed = 2;
  return (
    <Box pX="small" pY="small">
      <Skeleton speed={speed} width={340} height={58} viewBox="0 0 340 58">
        <circle cx="26" cy="28" r="20" />
        <rect x="64" y="16" rx="3" ry="3" width="40" height="8" />
        <rect x="118" y="12" rx="4" ry="4" width="40" height="16" />
        <rect x="64" y="35" rx="0" ry="0" width="300" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={340} height={58} viewBox="0 0 340 58">
        <circle cx="26" cy="28" r="20" />
        <rect x="64" y="16" rx="3" ry="3" width="40" height="8" />
        <rect x="118" y="12" rx="4" ry="4" width="40" height="16" />
        <rect x="64" y="35" rx="0" ry="0" width="270" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={340} height={58} viewBox="0 0 340 58">
        <circle cx="26" cy="28" r="20" />
        <rect x="64" y="16" rx="3" ry="3" width="40" height="8" />
        <rect x="118" y="12" rx="4" ry="4" width="40" height="16" />
        <rect x="64" y="35" rx="0" ry="0" width="200" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={340} height={58} viewBox="0 0 340 58">
        <circle cx="26" cy="28" r="20" />
        <rect x="64" y="16" rx="3" ry="3" width="40" height="8" />
        <rect x="118" y="12" rx="4" ry="4" width="40" height="16" />
        <rect x="64" y="35" rx="0" ry="0" width="190" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={340} height={58} viewBox="0 0 340 58">
        <circle cx="26" cy="28" r="20" />
        <rect x="64" y="16" rx="3" ry="3" width="40" height="8" />
        <rect x="118" y="12" rx="4" ry="4" width="40" height="16" />
        <rect x="64" y="35" rx="0" ry="0" width="240" height="8" />
      </Skeleton>
    </Box>
  );
};
export default ResultSearchItemLoader;
